
import AuthController from "@controllers/auth.controller";

export default function PatientSidebar({
  patientName = "Patient Name",
  onSignOut = () => {},
  showSignature = true,
  showQRCode = false,
  showSettings = false
}) {

  const handleSignOut = () => {
    AuthController.logout("/");
  };

  return (
    <div className="flex flex-col h-screen w-64 bg-white border-r">
      {/* Header with logo */}
      <div className="p-4 md:p-6 lg:p-8 flex justify-center">
  <img src="/img/Oshimed menu bar.png" alt="Logo" className="h-7" />
   </div>

      {/* Navigation Links */}
      <nav className="">
        <ul className="space-y-1">
          {/* Signature Link */}
          {showSignature && (
            <li>
              <div className="flex items-center py-4 text-sm bg-gradient-to-r from-indigo-200 to-white text-indigo-600 font-medium w-full">
                <span className="mr-3 ml-6 text-indigo-600">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <img src="/icons/sidebar/Signature.svg" className="w-6 h-6" alt="Signature" />
                  </div>
                </span>
                Signature
              </div>
            </li>
          )}

          {/* QR Code Link */}
          {showQRCode && (
            <li>
              <div className="flex items-center py-4 text-sm bg-gradient-to-r from-indigo-200 to-white text-indigo-600 font-medium w-full">
                <span className="mr-3 ml-6 text-indigo-600">
                  <div className="w-8 h-8 flex items-center justify-center">
                    <img src="/icons/sidebar/QR code.svg" className="w-6 h-6" alt="QR Code" />
                  </div>
                </span>
                QR Code
              </div>
            </li>
          )}
        {/* QR Code Link */}
        {showSettings && (
          <li>
          <div className="flex items-center py-4 text-sm bg-gradient-to-r from-indigo-200 to-white text-indigo-600 font-medium w-full">
            <span className="mr-3 ml-6 text-indigo-600">
              <div className="w-8 h-8 flex items-center justify-center">
                <img src="/icons/sidebar/Setting 1.svg" alt="Settings" className="w-6 h-6" />
              </div>
            </span>
            Settings
          </div>
          </li>
        )}

        </ul>
      </nav>

      <div className="flex-grow"></div>

      {/* User info and logout */}
      <div className="p-4 mb-4">
        <div className="bg-blue-200 w-[70%] rounded-xl py-2 flex items-center justify-between mx-auto">
          <div className="flex items-center mx-auto">
            <div>
              <p className="text-md mb-4 font-medium">{patientName}</p>
              <button onClick={handleSignOut} className="text-xm text-gray-600 flex items-center gap-2 mx-auto">
                Sign out <img className="h-5 w-5" alt="sign out" src="/icons/study/Sign out.svg" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
